// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"e8ab490a","348":"217c949e","571":"78b35755","924":"a93f618f"}[chunkId] + ".chunk.js";
};